// import React from "react";

// // const MainTitle = () => {

// //     return (
// //         <div className="sticky top-0 py-1 my-2 bg-orange-300" style={{ backgroundColor: "#4B0000" }}>
// //             <div className="text-center text-white">
// //                 <span className="font-bold text-[34px] tracking-tight">Bodeguita de Curicó</span>
// //             </div>
// //         </div>
// //     );
// // }

// // export default MainTitle;


// const MainTitle = () => {
//     return (
//         <div className="sticky top-0 my-2 bg-amber-50 border-t-[3px] border-b-[3px] border-[#4B0000] py-2 px-4">
//             <div className="text-center">
//                 <p className="text-[11px] italic text-amber-800 tracking-widest mb-0" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
//                     desde el valle
//                 </p>
//                 <p className="text-[28px] font-bold text-[#4B0000] leading-tight tracking-tight m-0" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
//                     Bodeguita de Curicó
//                 </p>
//             </div>
//         </div>
//     );
// }

// export default MainTitle;


import React from "react";

const MainTitle = () => {
    return (
        <div className="sticky top-0 z-20 bg-[#8c1d2f] px-4 py-3 shadow-lg lg:py-5">
            <div className="text-center">
                <p
                    className="text-[9px] lg:text-[11px] tracking-[0.3em] text-[#efb8c0] uppercase mb-0.5 lg:mb-1"
                    style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                >
                    desde el valle
                </p>
                <p
                    className="text-[24px] lg:text-[34px] font-bold text-[#f5f0e8] leading-tight tracking-tight m-0"
                    style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                >
                    Frutas a tu Casa
                </p>
            </div>
        </div>
    );
};

export default MainTitle;